export default __webpack_public_path__ + "static/media/6.1c1e1d25.png";